import _objectSpread from "@babel/runtime/helpers/objectSpread2";
export var LogTags = function LogTags() {
  var storage = {};

  function addTag(tag, value) {
    storage[tag] = value;
  }

  function getTags() {
    return _objectSpread({}, storage);
  }

  function setTags(tags) {
    storage = tags;
  }

  function updateTags(tags) {
    storage = _objectSpread(_objectSpread({}, storage), tags);
  }

  function clearTags() {
    storage = {};
  }

  function toString() {
    return JSON.stringify(storage);
  }

  return {
    addTag: addTag,
    clearTags: clearTags,
    setTags: setTags,
    toString: toString,
    updateTags: updateTags,
    getTags: getTags
  };
};